export default __webpack_public_path__ + "static/media/Cootie (2242).9f70645d.jpg";